import { render, staticRenderFns } from "./PasswordDimenticata.vue?vue&type=template&id=50f3c19c&"
import script from "./PasswordDimenticata.vue?vue&type=script&lang=js&"
export * from "./PasswordDimenticata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports